// extracted by mini-css-extract-plugin
module.exports = {"popupRootChild":"premiumPopup_popupRootChild__SvWFI"};